import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import Script from 'next/script'

export default function GTMScript({ gtmId }: { gtmId: string }) {
  const waitForCookieConsentFlag = useFeatureFlag('KYOTO_GTM_WAIT_FOR_COOKIE_CONSENT')
  const waitForCookieConsent = waitForCookieConsentFlag ? 'true' : 'false'

  return (
    <Script id="googleTagManager" data-cookieconsent="ignore" strategy="afterInteractive">
      {// language=JavaScript
        `
          function googleTagManagerLoad(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
            j.addEventListener("load", function() {
              var _ge = document.createEvent("CustomEvent");
              _ge.initCustomEvent("gtm_loaded", true, false, null);
              d.dispatchEvent(_ge);
            });
            f.parentNode.insertBefore(j, f);
          }

          function loadGTM() {
            if (document.readyState === "complete") {
                googleTagManagerLoad(
                  window,
                  document,
                  "script",
                  "dataLayer",
                  "${gtmId}"
                );
              } else {
                window.addEventListener(
                  "load",
                  function load() {
                    removeEventListener("load", load, false);
                    googleTagManagerLoad(
                      window,
                      document,
                      "script",
                      "dataLayer",
                      "${gtmId}"
                    );
                  },
                  false
                );
              }
          }

          if(${waitForCookieConsent}) {
            window.addEventListener('CookiebotOnDecline', function (e) {               
                loadGTM();
            }, false);

            window.addEventListener('CookiebotOnAccept', function (e) {
                loadGTM();
            }, false);
          }
          else {
            loadGTM();
          }
         
          
          `
      }
    </Script>
  )
}
